var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "80vh"
        }
      },
      model: {
        value: _vm.show_event,
        callback: function($$v) {
          _vm.show_event = $$v
        },
        expression: "show_event"
      }
    },
    [
      !_vm.event
        ? _c("q-modal-layout", [_c("div", [_vm._v("No event")])])
        : _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_event = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("event")) +
                        " - " +
                        _vm._s(_vm.event.first_event_date) +
                        "\n            "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end question-list" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s("EVENT!") +
                        "\n                "
                    )
                  ]
                )
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }